import React, { useEffect, useState } from 'react';
import SingleHotDeals from './SingleHotDeals';

const HeroArea = () => {


    const [hotProduct, setHotProduct] = useState([]);

    useEffect(() => {
        fetch("https://api.hiring.masterkey.tech/api/v1/products")
            .then(res => res.json())
            .then(data => {
                const filteredProducts = data.products[0].productData.filter(product => product.product_type === "hot deals for you");
                setHotProduct(filteredProducts);
            })
    }, [])





    return (
        <div>
            <div className="hero_area py-8"
            // style={{ backgroundImage: `url(${herobg})` }}
            >
                <div className="container">
                    <div className="hero_wrap  md:flex items-center md:gap-4">
                        <div className="md:max-w-[500px] w-full">
                            <h1 className="md:text-6xl text-4xl font-bold leading-tight mb-5 text-black">We picked some <span className='text-[#FFAE5D]'>cool things</span> for you!</h1>
                        </div>
                        <div className=" w-full">
                            <h2 className='text-2xl font-semibold text-black pb-3 border-b border-dashed mb-8'>hot deals for you {hotProduct?.length}</h2>
                            <div className='hot-deals-items grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-6 mt-12'>
                                {
                                    hotProduct?.slice(0, 5).map(singleHotProduct => <SingleHotDeals
                                        key={singleHotProduct?._id}
                                        singleHotProduct={singleHotProduct}
                                    />)
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeroArea;